const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const fetchWithAuth = async (url, options = {}) => {
    const response = await fetch(`${API_BASE_URL}${url}`, {
        ...options,
        credentials: 'include',
    });

    if (response.status === 401) {
        console.error('Authentication expired or failed for:', url);
        localStorage.removeItem('currentUser');
        window.location.href = '/login';
        throw new Error('Unauthorized');
    }

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
        throw new Error(errorData.detail || errorData.message || 'API request failed');
    }

    return response.json();
};

// Appliances API
export const fetchAppliances = async (familyId, filters = {}) => {
    const params = new URLSearchParams();
    for (const key in filters) {
        if (filters[key] !== undefined && filters[key] !== null) {
            params.append(key, filters[key]);
        }
    }
    const queryString = params.toString();
    return fetchWithAuth(`/v1/families/${familyId}/appliances${queryString ? `?${queryString}` : ''}`);
};

export const getAppliance = async (familyId, applianceId) => {
    return fetchWithAuth(`/v1/families/${familyId}/appliances/${applianceId}`);
};

export const createAppliance = async (familyId, applianceData) => {
    return fetchWithAuth(`/v1/families/${familyId}/appliances`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(applianceData),
    });
};

export const updateAppliance = async (familyId, applianceId, applianceData) => {
    return fetchWithAuth(`/v1/families/${familyId}/appliances/${applianceId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(applianceData),
    });
};

export const deleteAppliance = async (familyId, applianceId) => {
    return fetchWithAuth(`/v1/families/${familyId}/appliances/${applianceId}`, {
        method: 'DELETE',
    });
};

